import { render, staticRenderFns } from "./originSSF.vue?vue&type=template&id=67d7286e&"
import script from "./originSSF.vue?vue&type=script&lang=ts&"
export * from "./originSSF.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports